import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

// Create axios instance with cookie support
const apiClient = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, // Enable cookies for cross-origin requests
});

// Response interceptor for auth errors
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Skip redirect for /api/auth/me - AuthContext handles this in its own catch block
      const isAuthCheckRequest = error.config?.url?.includes('/auth/me');
      
      if (!isAuthCheckRequest) {
        // Token expired or invalid - redirect to login
        window.location.href = '/';
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;
